"use strict";
/**
 * 竞猜相关常量
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuessResult = exports.SessionStatus = exports.LAYOUT = exports.GuessUpDownValue = exports.GuessType = void 0;
/**
 * 竞猜类型
 * 1: 猜涨跌
 * 2: 猜收盘价
 */
exports.GuessType = {
    /** 猜涨跌 */
    UpDown: 1,
    /** 猜收盘价 */
    ClosePrice: 2,
};
/**
 * 猜涨跌取值
 * 1: 涨
 * 2: 跌
 */
exports.GuessUpDownValue = {
    /** 涨 */
    Up: 1,
    /** 跌 */
    Down: 2,
};
/**
 * 展示样式布局类型
 * 1: 平铺
 * 2: 轮播
 */
exports.LAYOUT = {
    /** 平铺 */
    FLAT: 1,
    /** 轮播 */
    CAROUSEL: 2,
};
/**
 * 场次状态（与后端表一致）
 * 2-已截止 3-已结算 4-已取消
 */
exports.SessionStatus = {
    /** 已截止 */
    Ended: 2,
    /** 已结算 */
    Settled: 3,
    /** 已取消 */
    Cancelled: 4,
};
/**
 * 竞猜结果（与后端表一致）
 * 0-未结算 1-胜 2-负 3-平
 */
exports.GuessResult = {
    /** 未结算 */
    Unsettled: 0,
    /** 胜 */
    Win: 1,
    /** 负 */
    Lose: 2,
    /** 平 */
    Draw: 3,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7R0FFRzs7O0FBRUg7Ozs7R0FJRztBQUNVLFFBQUEsU0FBUyxHQUFHO0lBQ3JCLFVBQVU7SUFDVixNQUFNLEVBQUUsQ0FBQztJQUNULFdBQVc7SUFDWCxVQUFVLEVBQUUsQ0FBQztDQUNQLENBQUM7QUFFWDs7OztHQUlHO0FBQ1UsUUFBQSxnQkFBZ0IsR0FBRztJQUM1QixRQUFRO0lBQ1IsRUFBRSxFQUFFLENBQUM7SUFDTCxRQUFRO0lBQ1IsSUFBSSxFQUFFLENBQUM7Q0FDRCxDQUFDO0FBRVg7Ozs7R0FJRztBQUNVLFFBQUEsTUFBTSxHQUFHO0lBQ2xCLFNBQVM7SUFDVCxJQUFJLEVBQUUsQ0FBQztJQUNQLFNBQVM7SUFDVCxRQUFRLEVBQUUsQ0FBQztDQUNMLENBQUM7QUFFWDs7O0dBR0c7QUFDVSxRQUFBLGFBQWEsR0FBRztJQUN6QixVQUFVO0lBQ1YsS0FBSyxFQUFFLENBQUM7SUFDUixVQUFVO0lBQ1YsT0FBTyxFQUFFLENBQUM7SUFDVixVQUFVO0lBQ1YsU0FBUyxFQUFFLENBQUM7Q0FDTixDQUFDO0FBRVg7OztHQUdHO0FBQ1UsUUFBQSxXQUFXLEdBQUc7SUFDdkIsVUFBVTtJQUNWLFNBQVMsRUFBRSxDQUFDO0lBQ1osUUFBUTtJQUNSLEdBQUcsRUFBRSxDQUFDO0lBQ04sUUFBUTtJQUNSLElBQUksRUFBRSxDQUFDO0lBQ1AsUUFBUTtJQUNSLElBQUksRUFBRSxDQUFDO0NBQ0QsQ0FBQyJ9